var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6005 8.54968C15.6008 8.55 15.6011 8.5503 15.0588 9.00219L15.6011 8.5503C15.8506 8.84979 15.8102 9.29489 15.5107 9.54446C15.2114 9.79387 14.7667 9.75363 14.517 9.45467C14.5169 9.45462 14.5169 9.45456 14.5169 9.45451L14.5165 9.45408L14.5149 9.4522L14.5033 9.43861C14.4922 9.42578 14.4746 9.40554 14.4507 9.37865C14.4028 9.32487 14.3296 9.24462 14.2329 9.14401C14.0392 8.94257 13.7523 8.6608 13.3862 8.34695C12.6499 7.71589 11.613 6.97237 10.3849 6.48109C9.16193 5.99192 7.76926 5.75993 6.28969 6.11503C4.81263 6.46953 3.17223 7.42748 1.4834 9.45408C1.23383 9.75357 0.788727 9.79404 0.489236 9.54446C0.189746 9.29489 0.149281 8.84979 0.398854 8.5503C2.23944 6.34157 4.12846 5.18187 5.96022 4.74225C7.78947 4.30322 9.48504 4.60065 10.9092 5.1703C12.3281 5.73786 13.497 6.58259 14.3049 7.27506C14.7108 7.62297 15.0306 7.93681 15.2505 8.16551C15.3606 8.27997 15.4459 8.37344 15.5049 8.4396C15.5343 8.47269 15.5572 8.49898 15.5733 8.51768L15.5924 8.53996L15.598 8.54666L15.5999 8.54886L15.6005 8.54968Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99991 12.7669C9.29941 12.7669 10.3529 11.7134 10.3529 10.4139C10.3529 9.11444 9.29941 8.06099 7.99991 8.06099C6.70042 8.06099 5.64697 9.11444 5.64697 10.4139C5.64697 11.7134 6.70042 12.7669 7.99991 12.7669Z",
    fill: "#FFB6BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 8.53158C6.96033 8.53158 6.11757 9.37434 6.11757 10.4139C6.11757 11.4535 6.96033 12.2963 7.99992 12.2963C9.03952 12.2963 9.88227 11.4535 9.88227 10.4139C9.88227 9.37433 9.03952 8.53158 7.99992 8.53158ZM5.17639 10.4139C5.17639 8.85454 6.44053 7.5904 7.99992 7.5904C9.55931 7.5904 10.8234 8.85454 10.8234 10.4139C10.8234 11.9733 9.55931 13.2375 7.99992 13.2375C6.44053 13.2375 5.17639 11.9733 5.17639 10.4139Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b37f7e648b0c004e0902493ae97fb4e1.svg";
export { ForwardRef as ReactComponent };